//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"Angle",1,0],[0,"AnnotationType",1,0],[0,"ApplyToAllFromSameComp",1,0],[0,"AreafillAngle",1,0],[0,"Color",1,0],[0,"CrosshatchFile",1,0],[0,"Distance",1,0],[0,"Material",1,0],[0,"Pattern",1,0],[0,"Scale",1,0],[0,"Tolerance",1,0],[0,"Width",1,0]],[[["identifier"],"FindCrosshatchFile",{R_:{filename:''}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.HatchFillSettingsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.HatchFillSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.HatchFillSettingsBuilder.AnnotationTypes = Object.freeze({
    "Crosshatch" : "Crosshatch", "AreaFill" : "AreaFill"});

export default SPLM;